import { Key } from "react";
import { Action, Dispatch } from "redux";
import { AxiosError, AxiosResponse } from "axios";
import { notification } from "antd";

import { ApiService } from "../../../services";
import { NavigationPath, history, showErrorNotification } from "../../../utils";
import { GET_USERS, GET_USER_BY_ID, SET_USER_TO_NULL } from "./types";
import { AddEditUserReq } from "../../../models";

export const registerUser =
  (user: AddEditUserReq) => async (dispatch: Dispatch<Action>) => {
    try {
      ApiService.post("/auth/register", user)
        .then((res: AxiosResponse) => {
          const { status } = res;
          if (status !== 200) {
            showErrorNotification("Kreiranje korisnika nije uspjelo");
            return;
          }
          notification.success({
            message: "Korisnik je kreiran.",
          });
          history.navigate(NavigationPath.USERS_ROUTE);
        })
        .catch((err: AxiosError) => {
          showErrorNotification("Kreiranje korisnika nije uspjelo", err);
          console.error(err);
        });
    } catch (err) {
      console.error(err);
    }
  };

export const getUsers = () => async (dispatch: Dispatch<Action>) => {
  try {
    ApiService.get("/user")
      .then((res) => {
        const { status, data } = res;
        if (status !== 200) {
          showErrorNotification("Učitavanje korisnika nije uspjelo");
          return;
        }
        dispatch({
          type: GET_USERS,
          payload: data.rows,
        });
      })
      .catch((err) => {
        showErrorNotification("Učitavanje korisnika nije uspjelo", err);
        console.log(err);
      });
  } catch (error) {
    console.log(error);
  }
};

export const getUserById =
  (id: string | undefined) => async (dispatch: Dispatch<Action>) => {
    try {
      if (!id) {
        return;
      }

      dispatch({
        type: SET_USER_TO_NULL,
      });
      ApiService.get(`user/${id}`)
        .then((res: AxiosResponse) => {
          const { status, data } = res;

          if (status !== 200) {
            showErrorNotification("Učitavanje korisnika nije uspjelo");
            return;
          }
          dispatch({
            type: GET_USER_BY_ID,
            payload: data,
          });
        })
        .catch((err: AxiosError) => {
          showErrorNotification("Učitavanje korisnika nije uspjelo", err);
          console.log(err);
        });
    } catch (err) {
      console.log(err);
    }
  };

export const updateUser =
  (user: AddEditUserReq, id: string) => async (dispatch: Dispatch<Action>) => {
    try {
      ApiService.put(`user/${id}`, user)
        .then((res: AxiosResponse) => {
          const { status } = res;

          if (status !== 200) {
            showErrorNotification("Izmjena korisnika nije uspjela");
            return;
          }
          notification.success({
            message: "Izmjene su sačuvane.",
          });
          history.navigate(NavigationPath.USERS_ROUTE);
        })
        .catch((err: AxiosError) => {
          showErrorNotification("Izmjena korisnika nije uspjela", err);
          console.log(err);
        });
    } catch (error) {
      console.log(error);
    }
  };

export const deleteUser = (ids: Key[]) => async (dispatch: Dispatch<any>) => {
  try {
    ApiService.delete(`user/`, {
      data: { ids },
    })
      .then((res: AxiosResponse) => {
        const { status } = res;

        if (status !== 204) {
          showErrorNotification("Brisanje korisnika nije uspjelo");
          return;
        }
        notification.success({
          message:
            ids.length === 1
              ? "Korisnik je obrisan."
              : "Korisnici su obrisani.",
        });
        dispatch(getUsers());
      })
      .catch((err: AxiosError) => {
        showErrorNotification("Brisanje korisnika nije uspjelo", err);
      });
  } catch (err) {
    showErrorNotification("Brisanje korisnika nije uspjelo", err);
  }
};

export const changePassword =
  (password: string, id: string) => async (dispatch: Dispatch<Action>) => {
    ApiService.put(`/user/${id}/password`, { password })
      .then((res: AxiosResponse) => {
        const { status } = res;
        if (status !== 200) {
          showErrorNotification("Promjena lozinke nije uspjela");
          return;
        }
        notification.success({
          message: "Lozinka je promijenjena.",
        });
      })
      .catch((err: AxiosError) => {
        showErrorNotification("Promjena lozinke nije uspjela", err);
      });
  };
